import PropTypes from 'prop-types';
import { ClipboardText, FolderSimplePlus, ListChecks } from '@phosphor-icons/react';

const getChartActionItems = (props) => [
  {
    key: 'send_to_chart',
    visible: props.canSendToChart,
    disabled: props.disabled || props.disableSendToChart,
    label: props.sendLabel,
    handler: props.onSendToChart,
    Icon: ClipboardText,
    iconWeight: 'fill',
    tutorial: 'chart-send-to-chart',
    description: 'Files this document in an existing patient’s chart.',
  },
  {
    key: 'create_chart',
    visible: props.canCreateChart,
    disabled: props.disabled || props.disableCreateChart,
    label: props.createChartLabel,
    handler: props.onCreateChart,
    Icon: FolderSimplePlus,
    tutorial: 'chart-create-chart',
    description: 'Creates a new patient chart and files this document.',
  },
  {
    key: 'create_task',
    visible: props.canCreateTask,
    disabled: props.disabled || props.disableCreateTask,
    label: props.createTaskLabel,
    handler: props.onCreateTask,
    Icon: ListChecks,
    description: props.createTaskLabel === 'Create Note' ? 'Creates a note in your EMR.' : 'Creates an EMR task without filing this document in the chart.',
  },
];

export default getChartActionItems;

export const chartActionPropTypes = {
  disabled: PropTypes.bool,
  canSendToChart: PropTypes.bool,
  canCreateChart: PropTypes.bool,
  canCreateTask: PropTypes.bool,
  disableSendToChart: PropTypes.bool,
  disableCreateChart: PropTypes.bool,
  disableCreateTask: PropTypes.bool,
  disabledExplanation: PropTypes.string,
  onSendToChart: PropTypes.func,
  onCreateChart: PropTypes.func,
  onCreateTask: PropTypes.func,
  sendLabel: PropTypes.string,
  createChartLabel: PropTypes.string,
  createTaskLabel: PropTypes.string,
};

export const chartActionDefaultProps = {
  disabled: false,
  canSendToChart: false,
  canCreateChart: false,
  canCreateTask: false,
  disableSendToChart: false,
  disableCreateChart: false,
  disableCreateTask: false,
  disabledExplanation: undefined,
  onSendToChart: () => {},
  onCreateChart: () => {},
  onCreateTask: () => {},
  sendLabel: 'Send to Chart',
  createChartLabel: 'Create Chart',
  createTaskLabel: 'Create Task',
};
